// Shared SEO blocks for the three free tool pages: tax calculator,
// insurance group checker, and free car check. Keeps cross-links and
// breadcrumbs consistent so each page helps the others rank.

const TOOLS = {
  tax: {
    href: "/car-tax-calculator/",
    label: "Car tax calculator",
    blurb: "How much is my car tax? Check by UK reg for yearly, six-month and monthly costs.",
  },
  insurance: {
    href: "/insurance-groups",
    label: "Insurance group checker",
    blurb: "See what insurance group your car is in, from 1 to 50.",
  },
  freeCheck: {
    href: "/free-car-check",
    label: "Free car check guide",
    blurb: "What a free UK car check actually covers, and what it leaves out.",
  },
};

function toolForBrand(key, tool, brandKey) {
  if (key === "tax" && brandKey === "servicebyreg") {
    return {
      ...tool,
      label: "Road tax check",
      blurb: "Enter a UK registration plate to see the road tax price. No make or model form.",
    };
  }
  if (key === "tax" && brandKey === "servicelad") {
    return {
      ...tool,
      label: "Check road tax",
      blurb: "Use the plate alone to see what road tax will cost. Skip make and model fields.",
    };
  }
  return tool;
}

export function RelatedFreeTools({ current, brandKey }) {
  const others = Object.entries(TOOLS)
    .filter(([key]) => key !== current)
    .map(([key, tool]) => toolForBrand(key, tool, brandKey));

  return (
    <section className="tax-related" aria-labelledby="related-free-tools">
      <h2 id="related-free-tools">More free vehicle checks</h2>
      <p>Other free tools you can run from a UK registration, no account needed.</p>
      <div className="tax-related-grid">
        {others.map((tool) => (
          <a key={tool.href} href={tool.href}>
            <strong>{tool.label}</strong>
            <span>{tool.blurb}</span>
          </a>
        ))}
      </div>
    </section>
  );
}

export function ToolFaq({ title, items }) {
  return (
    <section className="tax-faq" aria-labelledby="tool-faq-heading">
      <h2 id="tool-faq-heading">{title}</h2>
      {items.map(([question, answer]) => (
        <details key={question}>
          <summary>{question}</summary>
          <p>{answer}</p>
        </details>
      ))}
    </section>
  );
}

export function toolPageSchemas({ brand, canonical, name, description, alternateName, pathLabel }) {
  const home = `https://${brand.domain}/`;
  return [
    {
      "@type": "WebApplication",
      name,
      alternateName,
      url: canonical,
      description,
      applicationCategory: "FinanceApplication",
      operatingSystem: "Any",
      offers: { "@type": "Offer", price: "0", priceCurrency: "GBP" },
      provider: { "@type": "Organization", name: brand.name, url: home },
      dateModified: "2026-08-22",
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: home },
        { "@type": "ListItem", position: 2, name: pathLabel, item: canonical },
      ],
    },
  ];
}
